import {
    SkyNetDataGridProps,
} from 'app/PoC/DataGridDemoPages/components/SkyNetDataGrid'
import {
    WithId,
} from 'app/types/common.types'
import {
    RolesTypes,
} from 'app/utils/hasPermission'

export type DetailPanelComponentProps = {
    id?: number | string,
    onCopy?: () => void,
    onSuccess: ({
        id, toCollapse,
    }: { id?: number | string, toCollapse?: boolean }) => void | Promise<void>,
    onCancel: () => void | Promise<void>,
}

export type DetailPanelComponent = (props: DetailPanelComponentProps) => JSX.Element

export enum Action {
    Copy = 'Copy',
    Create = 'Create',
}

type ExpandableActionComponent = {
    component: DetailPanelComponent,
    onSuccess?: ({
        id,
    }: WithId<number>) => void
    accessOnly?: RolesTypes[]
}

export type ExpandableActionComponents = {
    Copy?: ExpandableActionComponent,
    Update?: ExpandableActionComponent,
    Create?: ExpandableActionComponent
}

export type SkyNetDataGridExpandableProps =
    Omit<SkyNetDataGridProps, 'getDetailPanelContent'>
    & {
    ActionComponents: ExpandableActionComponents,
    autoOpenForm?: boolean,
    detailPanelHeight?: number,
    key?: string,
}
